<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/177XAoE/tc-custom/9781524854942.jpg?1724855613286" alt="This image is the cover for the book She Book"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">She Book
      </h1>
      <p class="bookDescription body article font2">
        <p>Crafting together the power of words and womanhood, writer Tanya Markul has written a completely unique poetry collection fit for the phenomenal readers of today.<br/><br/>In Tanya's words, "May we raise the bar for how we live our lives. May we ridiculously increase the amount of peace, play, creativity, beauty, love, and joy in everything we do. May we all sip from the wisdom of our suffering. And awaken with the courage to share our stories that can heal our inner and outer worlds."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tanya Markul
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?038e2f6d